import { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AppLayout } from './layouts';
import Loader from './components/loader';
import ErrorBoundary from './ErrorBoundary';

const ReportPage = lazy(() => import('./pages/report'));
const ErrorPage = lazy(() => import('./pages/error'));

function App() {
    return (
        <>
            <ToastContainer />
            <ErrorBoundary>
                <Suspense fallback={<Loader fullscreen />}>
                    <Routes>
                        <Route path="/" element={<AppLayout />}>
                            <Route index element={<ReportPage />} />
                        </Route>
                        <Route path="*" element={<ErrorPage message="Page not found." />} />
                    </Routes>
                </Suspense>
            </ErrorBoundary>
        </>
    );
}

export default App;
